import React from "react";
import styled from "styled-components";
import { T } from "../../theme";
import { BENEFITS, VALUES } from "../../data/careers";
import Reveal from "../Reveal";
import { Band, Shell, Eyebrow, Heading, Lead, Head } from "./ui";

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;

  @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 480px) { grid-template-columns: 1fr; }
`;

const Item = styled.div`
  background: ${T.card};
  border: 1.5px solid ${T.border};
  border-radius: 16px;
  padding: 20px;
  transition: border-color 0.16s, transform 0.16s, box-shadow 0.16s;

  &:hover {
    border-color: color-mix(in srgb, var(--purple) 34%, transparent);
    transform: translateY(-3px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  }
`;

const Ico = styled.div`
  font-size: 1.5rem;
  line-height: 1;
  margin-bottom: 14px;
`;

const IName = styled.h3`
  font-size: 0.92rem;
  font-weight: 800;
  color: ${T.text};
  margin-bottom: 6px;
  letter-spacing: -0.01em;
`;

const IDesc = styled.p`
  font-size: 0.8rem;
  color: ${T.muted};
  line-height: 1.6;
`;

/* ── valores ── */
const ValuesWrap = styled.div`
  margin-top: clamp(36px, 5vw, 56px);
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border: 1.5px solid ${T.border};
  border-radius: 18px;
  overflow: hidden;

  @media (max-width: 760px) { grid-template-columns: 1fr 1fr; }
  @media (max-width: 460px) { grid-template-columns: 1fr; }
`;

const Value = styled.div`
  padding: 24px 22px;
  border-right: 1px solid ${T.border};
  border-bottom: 1px solid ${T.border};
  background: ${T.bg};

  &:last-child { border-right: none; }

  @media (min-width: 761px) {
    border-bottom: none;
    &:nth-child(4n) { border-right: none; }
  }
`;

const VNum = styled.span`
  font-size: 0.72rem;
  font-weight: 800;
  color: var(--purple);
  letter-spacing: 0.04em;
`;

const VTitle = styled.h3`
  font-size: 0.96rem;
  font-weight: 800;
  color: ${T.text};
  margin: 10px 0 7px;
  letter-spacing: -0.01em;
`;

const VDesc = styled.p`
  font-size: 0.8rem;
  color: ${T.muted};
  line-height: 1.6;
`;

export default function Benefits() {
  return (
    <Band id="beneficios" aria-labelledby="ben-title">
      <Shell>
        <Reveal>
          <Head>
            <Eyebrow>Por que a Guebly</Eyebrow>
            <Heading id="ben-title">Um lugar feito para quem quer construir.</Heading>
            <Lead>
              Sem firula de benefício de fachada. Aqui o combo é autonomia real, impacto
              de verdade e um time que cobra alto cuidando bem das pessoas.
            </Lead>
          </Head>
        </Reveal>

        <Grid>
          {BENEFITS.map((b, i) => (
            <Reveal key={b.title} delay={(i % 4) * 60}>
              <Item>
                <Ico aria-hidden="true">{b.icon}</Ico>
                <IName>{b.title}</IName>
                <IDesc>{b.desc}</IDesc>
              </Item>
            </Reveal>
          ))}
        </Grid>

        <Reveal>
          <ValuesWrap>
            {VALUES.map((v, i) => (
              <Value key={v.title}>
                <VNum>0{i + 1}</VNum>
                <VTitle>{v.title}</VTitle>
                <VDesc>{v.desc}</VDesc>
              </Value>
            ))}
          </ValuesWrap>
        </Reveal>
      </Shell>
    </Band>
  );
}
